import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../General/Modal';
import './ConfirmSendModal.scss';

const ConfirmSendModal = ({ isOpen, onClose, onConfirm, recipientCount }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal close={onClose} title='Confirm send'>
      <div className='confirm-send-modal-outer'>
        <p className='confirm-send-modal-message'>
          Are you sure you want to send this message to {recipientCount} recipient{recipientCount !== 1 ? 's' : ''}?
        </p>
        {recipientCount > 100000 && (
          <div className='confirm-send-modal-warning'>This is a large send and the request may take a couple minutes to process.</div>
        )}
        <div className='confirm-send-modal-actions'>
          <button type='button' className='confirm-send-modal-btn confirm-send-modal-btn-secondary' onClick={onClose}>
            Cancel
          </button>
          <button type='button' className='confirm-send-modal-btn confirm-send-modal-btn-primary' onClick={handleConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmSendModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  recipientCount: PropTypes.number.isRequired
};

export default ConfirmSendModal;
